export default __webpack_public_path__ + "static/media/IconFormalAssignments.d5b00295.png";